var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',[(_vm.content)?[(_vm.content.title)?_c('h2',{staticClass:"mb-5"},[_vm._v(_vm._s(_vm.content.title))]):_vm._e(),_c('div',{domProps:{"innerHTML":_vm._s(_vm.renderedContent)}})]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }